/**
 * Определяет, является ли текущий браузер Safari
 *
 * Важно: Chrome и другие Chromium-браузеры также содержат "Safari" в User-Agent,
 * поэтому необходимо исключить их из проверки
 *
 * Примеры User-Agent строк:
 * Safari: "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/16.1 Safari/605.1.15"
 * Chrome: "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/108.0.0.0 Safari/537.36"
 * Edge: "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/108.0.0.0 Safari/537.36 Edg/108.0.1462.54"
 *
 * @returns {boolean} true если это Safari, false если другой браузер
 */
export const getIsSafari = (): boolean => {
  // Проверяем доступность navigator
  if (typeof navigator === 'undefined' || !navigator.userAgent) {
    return false;
  }

  const userAgent = navigator.userAgent;

  // Более надежная проверка через регулярное выражение
  // Проверяет наличие "safari", но исключает "chrome" и "android"
  const regexMethod = /^((?!chrome|android).)*safari/i.test(userAgent);

  // Альтернативный метод через includes (для совместимости)
  const includesMethod =
    userAgent.includes('Safari') &&
    !userAgent.includes('Chrome') &&
    !userAgent.includes('Chromium') &&
    !userAgent.includes('Edge');

  // Используем регулярное выражение как основной метод,
  // includes как fallback для совместимости
  return regexMethod || includesMethod;
};

/**
 * Кэшированное значение для оптимизации производительности
 */
let cachedIsSafari: boolean | null = null;

/**
 * Получает значение с кэшированием для избежания повторных вычислений
 * @returns {boolean} true если это Safari
 */
export const isSafari = (): boolean => {
  if (cachedIsSafari === null) {
    cachedIsSafari = getIsSafari();
  }
  return cachedIsSafari;
};

/**
 * Сбрасывает кэш (полезно для тестирования)
 */
export const resetSafariCache = (): void => {
  cachedIsSafari = null;
};
